import React from 'react';

import { Box, BoxProps, rem } from '@vimeo/bokeh';

/**
 * Video frame + lock glyph used for cold-storage affordances (thumbnails,
 * privacy badge, privacy filter). Matches design-system cold-storage spec.
 */
export const ColdStorageVideoLockedIcon = ({ boxSize = rem(16), ...props }: BoxProps) => (
  <Box
    as="svg"
    viewBox="0 0 22 22"
    fill="none"
    aria-hidden="true"
    role="presentation"
    boxSize={boxSize}
    {...props}
  >
    <path
      d="M11.917 4.5835C11.917 5.08967 11.5067 5.5 11.0005 5.5H5.5C4.48759 5.5 3.66717 6.32064 3.66699 7.33301V14.667C3.66717 15.6794 4.48759 16.5 5.5 16.5H16.5C17.5124 16.5 18.3328 15.6794 18.333 14.667V12.834C18.333 12.3275 18.7436 11.917 19.25 11.917C19.7564 11.917 20.167 12.3275 20.167 12.834V14.667C20.1668 16.6919 18.5249 18.333 16.5 18.333H5.5C3.47506 18.333 1.83318 16.6919 1.83301 14.667V7.33301C1.83318 5.30811 3.47506 3.66699 5.5 3.66699H11.0005C11.5067 3.66699 11.917 4.07732 11.917 4.5835Z"
      fill="currentColor"
    />
    <path
      d="M20.2426 3.67201V2.63542C20.2426 1.93646 19.965 1.26613 19.4707 0.771896C18.9765 0.277659 18.3062 0 17.6072 0C16.9082 0 16.2379 0.277659 15.7437 0.771896C15.2494 1.26613 14.9718 1.93646 14.9718 2.63542V3.67201C14.4592 3.85325 14.0151 4.18862 13.7006 4.63213C13.386 5.07564 13.2164 5.60558 13.2148 6.14931V7.90625C13.2148 8.60521 13.4925 9.27553 13.9867 9.76977C14.481 10.264 15.1513 10.5417 15.8503 10.5417H19.3641C20.0631 10.5417 20.7334 10.264 21.2277 9.76977C21.7219 9.27553 21.9996 8.60521 21.9996 7.90625V6.14931C21.998 5.60558 21.8284 5.07564 21.5138 4.63213C21.1993 4.18862 20.7553 3.85325 20.2426 3.67201ZM16.7287 2.63542C16.7287 2.40243 16.8213 2.17899 16.986 2.01424C17.1508 1.8495 17.3742 1.75694 17.6072 1.75694C17.8402 1.75694 18.0636 1.8495 18.2284 2.01424C18.3931 2.17899 18.4857 2.40243 18.4857 2.63542V3.51389H16.7287V2.63542ZM20.2426 7.90625C20.2426 8.13924 20.1501 8.36268 19.9853 8.52742C19.8206 8.69217 19.5971 8.78472 19.3641 8.78472H15.8503C15.6173 8.78472 15.3938 8.69217 15.2291 8.52742C15.0643 8.36268 14.9718 8.13924 14.9718 7.90625V6.14931C14.9718 5.91632 15.0643 5.69288 15.2291 5.52813C15.3938 5.36339 15.6173 5.27083 15.8503 5.27083H19.3641C19.5971 5.27083 19.8206 5.36339 19.9853 5.52813C20.1501 5.69288 20.2426 5.91632 20.2426 6.14931V7.90625Z"
      fill="currentColor"
    />
    <path
      d="M9.54883 9.28205C9.54883 8.83691 10.0107 8.56168 10.3743 8.79013L13.1001 10.5029C13.4577 10.7276 13.4577 11.2719 13.1001 11.4966L10.3742 13.2092C10.0107 13.4377 9.54883 13.1624 9.54883 12.7173V9.28205Z"
      fill="currentColor"
    />
  </Box>
);
